import queryString from 'query-string';


export function getLocationQuery(location) {
  return queryString.parse(location.search);
}

export function getUrlSearch(parsed) {
  return queryString.stringify(parsed);
}

export function getHashValue(key) {
  const matches = window.location.hash.match(new RegExp(`${key}=([^&]*)`));
  return matches ? matches[1] : null;
}



// WEBPACK FOOTER //
// ./src/shared/utils/url.js